import { FC } from 'react'
import DeactivateNotificationIntegration from '@/components/modals/DeactivateNotificationIntegration'

interface DeactivateTelegramNotificationBotProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  integrationId?: number | null
  botUsername?: string | null
}

const DeactivateTelegramNotificationBot: FC<DeactivateTelegramNotificationBotProps> = ({
  botUsername,
  ...props
}) => (
  <DeactivateNotificationIntegration
    provider="telegram"
    displayHandle={botUsername}
    {...props}
  />
)

export default DeactivateTelegramNotificationBot
